import { SellerRequestEndpoints } from '@/modules/request/seller-request/api/sellerRequestEndpoints'

/**
 * Seller Request endpoint instance
 * instantiate Seller Request api class with a different api path
 */
export const sellerRequestEndpoints = new SellerRequestEndpoints()
